import cn from 'classnames';
import { forwardRef, HTMLProps, MouseEventHandler } from 'react';
import { SizeType, VariantType } from '../../types/props';
import s from './button.module.css';
import { useRouter } from '../../hooks/use-router';

export interface ButtonProps extends Omit<HTMLProps<HTMLButtonElement>, 'size'> {
  size?: SizeType;
  variant?: VariantType;
  type?: HTMLButtonElement['type'];
  fullWidth?: boolean;
  link?: {
    href: string;
    target?: string;
  };
  hrefBack?: boolean;
  outline?: boolean;
}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>((props, ref) => {
  const {
    size = 'md',
    variant = 'primary',
    type = 'button',
    className,
    disabled,
    fullWidth,
    onClick,
    hrefBack,
    outline = true,
    ...other
  } = props;

  const classNames = cn(
    s.component,
    className,
    s[size],
    s[variant],
    disabled && s.disabled,
    fullWidth && s.fullWidth,
    outline && s.outline,
  );

  const { goBack } = useRouter();

  const handleClick: MouseEventHandler<HTMLButtonElement> = (e) => {
    onClick?.(e);
    if (hrefBack) {
      goBack();
    }
  };

  return (
    <button
      {...other}
      ref={ref}
      className={classNames}
      type={type}
      onClick={handleClick}
      tabIndex={disabled ? -1 : 0}
    />
  );
});
